<template>
  <div class="global-container">
    <div class="space-3"></div>
    <div class="impressum">
      <h1>Impressum</h1>
      <div class="impressum-container">
        <div class="impressum-item">
          <h3>Vereinsname</h3>
          <p>Gewerblicher Verein</p>
          <p>helping heads – projektentwicklung</p>
        </div>
        <div class="impressum-item">
          <h3>ZVR-Nummer</h3>
          <p>10627&nbsp;99063</p>
        </div>
        <div class="impressum-item">
          <h3>Anschrift</h3>
          <p>Ratzersdorfer&nbsp;Weg&nbsp;49</p>
          <p>3100 St.Pölten</p>
          <p>Österreich</p>
        </div>
        <div class="impressum-item">
          <h3>Vertretungsberechtigter Vorstand</h3>
          <p>Kurt Berger, Obmann</p>
        </div>
        <div class="impressum-item">
          <h3>Kontakt</h3>
          <a href="tel:43664b3322677" class="impressum-link"
            >T: +43 664 33 22 677
          </a>
          <a href="mailto:kurt@helpingheads.at" class="impressum-link"
            >kurt@helpingheads.at
          </a>
          <a
            href="https://www.helpingheads.at/"
            target="_blank"
            class="impressum-link"
            >www.helpingheads.at
          </a>
        </div>
        <div class="impressum-item">
          <h3>Vereinszweck</h3>
          <p>Förderung und Pflege von Kunst und Kultur.</p>
        </div>
        <div class="impressum-item">
          <h3>Haftungsausschluss</h3>
          <p>
            Die Inhalte dieser Webseite werden mit größtmöglicher Sorgfalt
            erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der
            Inhalte können wir jedoch keine Gewähr übernehmen. Die Nutzung der
            Inhalte der Webseite erfolgt auf eigene Gefahr des Nutzers.
          </p>
        </div>
        <div class="impressum-item">
          <h3>Urheberrecht</h3>
          <p>
            Die auf dieser Webseite veröffentlichten Inhalte unterliegen dem
            österreichischen Urheberrecht. Jede vom österreichischen
            Urheberrecht nicht zugelassene Verwertung bedarf der vorherigen
            schriftlichen Zustimmung des jeweiligen Autors oder Urhebers.
          </p>
        </div>
        <div class="impressum-item">
          <h3>Webdesign</h3>
          <p>Florian Prassé</p>
          <a
            href="https://www.florianprassee.at/"
            target="_blank"
            class="impressum-link"
            >www.florianprassee.at
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script></script>

<style scoped lang="scss">
.impressum {
  h1 {
    margin-bottom: map-get($spaces, lg);
  }
  h3 {
    margin-bottom: map-get($spaces, xxs);
  }
  .impressum-container {
    display: flex;
    flex-direction: column;
    gap: map-get($spaces, lg);
    .impressum-item {
      display: flex;
      flex-direction: column;
      a {
        font-size: 1.25rem;
        line-height: 1.5;
        color: $text--muted;
        text-decoration: underline;
        width: fit-content;
        &:hover {
          color: $text--col;
        }
      }
    }
  }
}
</style>
